var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 128 128",
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    viewBox: "0 0 128 128",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40,18.3V14c0-5.5,4.5-10,10-10h45.9c2.7,0,5.2,1.1,7.1,2.9l14.1,14.1c1.9,1.9,2.9,4.4,2.9,7.1V99  c0,5.5-4.5,10-10,10H85.3",
    fill: "#E5E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94,109V43.1c0-5.3-2.1-10.4-5.9-14.1L74,14.9C70.2,11.1,65.2,9,59.9,9H41.3c-0.9,1.5-1.3,3.2-1.3,5v4.3  L85.3,109H94z",
    opacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74,124H14c-5.5,0-10-4.5-10-10V29c0-5.5,4.5-10,10-10h45.9c2.7,0,5.2,1.1,7.1,2.9l14.1,14.1  c1.9,1.9,2.9,4.4,2.9,7.1V114C84,119.5,79.5,124,74,124z",
    fill: "#FFFFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14,114V29c0-5.5,4.5-10,10-10H14C8.5,19,4,23.5,4,29v85c0,5.5,4.5,10,10,10h10C18.5,124,14,119.5,14,114z",
    fill: "#E5E6E6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14,125.5h60c6.3,0,11.5-5.2,11.5-11.5v-3.5H110c6.3,0,11.5-5.2,11.5-11.5V28.1c0-3.1-1.2-6-3.4-8.1L104,5.9  c-2.2-2.2-5.1-3.4-8.1-3.4H50c-6.3,0-11.5,5.2-11.5,11.5v3.5H14C7.7,17.5,2.5,22.7,2.5,29v85C2.5,120.3,7.7,125.5,14,125.5z   M41.5,14c0-4.7,3.8-8.5,8.5-8.5h45.9c2.3,0,4.4,0.9,6,2.5L116,22.1c1.6,1.6,2.5,3.7,2.5,6V99c0,4.7-3.8,8.5-8.5,8.5H85.5v-17H109  c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5H85.5v-17H109c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5H85.5V43.1c0-3.1-1.2-6-3.4-8.1  L68,20.9c-2.2-2.2-5.1-3.4-8.1-3.4H41.5V14z M5.5,29c0-4.7,3.8-8.5,8.5-8.5h45.9c2.3,0,4.4,0.9,6,2.5L80,37.1c1.6,1.6,2.5,3.7,2.5,6  V114c0,4.7-3.8,8.5-8.5,8.5H14c-4.7,0-8.5-3.8-8.5-8.5V29z",
    fill: "#4A374F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19,105.5h50c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5H19c-0.8,0-1.5,0.7-1.5,1.5S18.2,105.5,19,105.5z",
    fill: "#4A374F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19,85.5h50c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5H19c-0.8,0-1.5,0.7-1.5,1.5S18.2,85.5,19,85.5z",
    fill: "#4A374F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.a9dce8a3cb2201f9aa1ab427cb7f93d6.svg";
export { ForwardRef as ReactComponent };